import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import React__default from 'react';

function _filterChildren(children) {
  var _context;
  var queries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var matchesList = arguments.length > 2 ? arguments[2] : undefined;
  // TODO: Add `React.isValidElement` check here and then update types in helper functions to be `ReactElement` instead of `ReactNode`. This likely will require some sort of change in `Combobox` v1.

  // Single ReactChild
  if (React__default.Children.count(children) === 1 && !_Array$isArray(children)) {
    return _findMatch(children, queries, matchesList);
  }
  // Array of ReactChild
  return _mapInstanceProperty(_context = React__default.Children).call(_context, children, function (child) {
    return _findMatch(child, queries, matchesList);
  });
}

// Returns ReactChild
function _findMatch(child, queries, matchesList) {
  var _newChild;
  var newChild = child;
  var foundMatch = false;
  var i;
  for (i = 0; i < queries.length; i += 1) {
    var _queries$i = queries[i],
      matcher = _queries$i.matcher,
      _queries$i$modifier = _queries$i.modifier,
      modifier = _queries$i$modifier === void 0 ? function (c) {
        return c;
      } : _queries$i$modifier;
    if (matcher(child)) {
      newChild = modifier(child, matchesList[i].length, matchesList);
      foundMatch = true;
      break;
    }
  }
  if ((_newChild = newChild) !== null && _newChild !== void 0 && (_newChild = _newChild.props) !== null && _newChild !== void 0 && _newChild.children) {
    var modifiedChildren = _filterChildren(newChild.props.children, queries, matchesList);
    newChild = /*#__PURE__*/React__default.cloneElement(newChild, {
      children: modifiedChildren
    });
  }
  if (foundMatch && newChild) {
    matchesList[i].push(newChild);
  }
  return newChild;
}

// [ReactNode[], ReactNode[][]]

function filterChildren(children, queries) {
  var matchesList = _mapInstanceProperty(queries).call(queries, function () {
    return [];
  });
  return [_filterChildren(children, queries, matchesList), matchesList];
}

export { filterChildren as default };
